module.exports = __webpack_public_path__ + "img/newbg.45f41699.jpg";